module.exports = __webpack_public_path__ + "static/media/56 - Logo PPI Groningen.902c0862.png";